import { useState, useEffect } from 'react';
import { useTranslate } from 'src/locales';
import { getHelpUrl } from 'src/services/service-handlers/PublicService';
import { paths } from 'src/routes/paths';

const DEFAULT_EN = { url: paths.faqs, label: 'Need help?' };
const DEFAULT_ES = { url: paths.faqs, label: '¿Necesita ayuda?' };

export function useHelpUrl(): { url: string; label: string } {
  const { currentLang } = useTranslate();
  const lang = currentLang?.value === 'es' ? 'es' : 'en';
  const [byLang, setByLang] = useState<{
    en: { url: string; label: string };
    es: { url: string; label: string };
  }>({ en: DEFAULT_EN, es: DEFAULT_ES });

  useEffect(() => {
    getHelpUrl()
      .then((res) => {
        if (res?.en || res?.es) {
          setByLang({
            en: res.en
              ? { url: res.en.url || paths.faqs, label: res.en.label || DEFAULT_EN.label }
              : DEFAULT_EN,
            es: res.es
              ? { url: res.es.url || paths.faqs, label: res.es.label || DEFAULT_ES.label }
              : DEFAULT_ES,
          });
        }
      })
      .catch(() => {});
  }, []);

  return byLang[lang];
}
